
const initialState = {
  clientId: 1
}

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default clientReducer
